__turbopack_context__.v({
  "betaBadge": "MessagesContent-module__7cSWDq__betaBadge",
  "loaderContainer": "MessagesContent-module__7cSWDq__loaderContainer",
  "mainBody": "MessagesContent-module__7cSWDq__mainBody",
  "objectiveActionBtn": "MessagesContent-module__7cSWDq__objectiveActionBtn",
  "objectiveField": "MessagesContent-module__7cSWDq__objectiveField",
  "selector": "MessagesContent-module__7cSWDq__selector",
  "selectors": "MessagesContent-module__7cSWDq__selectors",
  "tabContent": "MessagesContent-module__7cSWDq__tabContent",
  "titleWithBeta": "MessagesContent-module__7cSWDq__titleWithBeta",
});
